import styled from "styled-components";

export const Trigger = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
`;

export const HidingParent = styled.div<{ show: boolean; height: string }>`
  overflow: hidden;
  transition: height 0.4s linear;
  height: ${({ show, height }) => (show ? height : "0px")};
`;
